import get from 'lodash/get'
import EventBus from '@/event-bus/EventBus'
import { sdkEventTypes } from '@/enum/sdkEvents'
import i18n from '@/i18n'
import useNotifyService from '@/composables/useNotifyService'

const $notify = useNotifyService

const sdkMessages = {
    missingToken: 'A token property should be provided',
    serverConnectionError: 'Could not find any server to establish connection with',
}

const parseCatch = (apiError, showAxiosErrorMessage = false, messagePrefix = '') => {
    let message

    const responseData = get(apiError.response, 'data')
    if (responseData) {
        const responseMessage = get(responseData, 'message')
        const responseDescription = get(responseData, 'Description')
        if (responseDescription) {
            message = responseDescription
        } else if (responseMessage) {
            message = responseMessage
        }
    } else if (apiError.message) {
        message = apiError.message
    }
    const status = get(apiError, 'response.status')
    let title
    if (status === 401) {
        message = i18n.t('invalid.token.message')
        title = i18n.t('invalid.token.title')
    }
    if (message === sdkMessages.serverConnectionError) {
        title = i18n.t('errors.realtime.connection.title')
        message = i18n.t('errors.realtime.connection.message')
    }

    if (showAxiosErrorMessage && message && shouldDisplayNotification(apiError)) {
        const messageConfig = {
            title,
            message: `${messagePrefix} ${message}`,
        }
        $notify.add({
            type: 'error',
            ...messageConfig,
        })

        throw apiError
    }
}

EventBus.on(sdkEventTypes.CONNECT_ERROR, () => {
    $notify.add({
        type: 'error',
        title: i18n.t('errors.realtime.connection.title'),
        message: i18n.t('errors.realtime.connection.message2'),
    })
})
EventBus.on(sdkEventTypes.CONNECT_TIMEOUT, () => {
    $notify.add({
        type: 'error',
        title: i18n.t('errors.realtime.timeout.title'),
        message: i18n.t('errors.realtime.timeout.description'),
    })
})
const messagesToSkip = [ sdkMessages.missingToken, 'Network Error' ] // These are already handled in other places

function shouldDisplayNotification (apiError) {
    return !messagesToSkip.includes(apiError.message)
}

export default parseCatch
